import React, { FunctionComponent, ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

import SnackBarContextProvider from '../../../features/shared/components/snack-bar-context/SnackBarContext';
import Container from '../../../features/shared/components/ui/Container';
import Typography from '../../../features/shared/components/ui/Typography';
import { PageLayoutProps } from './models/page-layout-props.model';

export const PageLayout: FunctionComponent<PageLayoutProps> = ({
  title,
}: PageLayoutProps): ReactElement => {
  return (
    <Container
      maxWidth={false}
      sx={{
        mt: 3,
        mr: 'unset',
        ml: 'unset',
        boxSizing: 'unset',
        padding: 0,
        ['@media(min-width: 600px)']: {
          padding: 0,
        },
      }}
    >
      <SnackBarContextProvider>
        <Typography
          variant="h1"
          sx={{
            fontSize: '32px',
            fontWeight: 300,
            marginTop: '54px',
            marginBottom: '11px',
          }}
        >
          {title}
        </Typography>

        <Outlet />
      </SnackBarContextProvider>
    </Container>
  );
};
